import {
  isClientBonusFinishedDetailsStatus,
  isClientFreespinFinishedDetailsStatus,
} from 'common/Notifications/Popups/FinishedBonusDetails/finishedBonusDetailsShared';

import { resolveBonusEntity } from './resolveBonusEntity';

export const isFinishedEntity = resolved => {
  if (!resolved) {
    return false;
  }

  if (resolved.kind === 'freespin') {
    return isClientFreespinFinishedDetailsStatus(resolved.entity.status);
  }

  if (resolved.kind === 'bonus') {
    return isClientBonusFinishedDetailsStatus(resolved.entity.status);
  }

  return false;
};

export const isFinishedBonusRoute = (bonusId, feed, loading) => {
  if (loading || !bonusId) {
    return false;
  }

  const resolved = resolveBonusEntity(bonusId, {
    availableTemplates: feed.availableTemplates,
    clientBonuses: feed.clientBonuses,
    freespins: feed.freespins,
  });

  return isFinishedEntity(resolved);
};
